export default __webpack_public_path__ + "c13c81631df69362bdabac3582a987a0.jpeg";